module.exports = __webpack_public_path__ + "img/mainImg.07a18a8e.png";